import { encodeBase64URI } from "utils";
import {
    GetDeliveryPromiseOfferRankingRequest,
    GetWaitlistSubscriptionStatusRequest,
    SubscribeToWaitlistRequest
} from "./types";

export const Urls = {
    GET_DELIVERY_PROMISES_OFFER_RANKING: (request: GetDeliveryPromiseOfferRankingRequest) => {
        const queryStr = JSON.stringify(request)
        const queryBase64 = encodeBase64URI(queryStr)
        return `/dp/retrieve/delivery-promise?query=${queryBase64}`
    },
    GET_WAITLIST_SUBSCRIPTION_STATUS: (request: GetWaitlistSubscriptionStatusRequest) => `/dashboard/getWaitlistSubscriptionStatus?${new URLSearchParams(request as any).toString()}`,
    SUBSCRIBE_TO_WAITLIST: (request: SubscribeToWaitlistRequest) => `/dashboard/subscribeToWaitlist?${new URLSearchParams(request as any).toString()}`,
}